function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultSchema } from './schema';
import Debug from './debug';

const multipleInstances = element => {
  if (['checkbox', 'radio'].includes(element.type)) {
    return document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]")).length > 1;
  }

  return false;
};

const collectCheckedOptions = element => {
  return Array.from(element.querySelectorAll('option:checked')).concat(Array.from(document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]"))).filter(elem => elem.checked)).map(o => o.value);
}; // Returns a string value for the passed array.
//
//   attributeValue(['', 'one', null, 'two', 'three ']) // 'one two three'
//


export const attributeValue = function () {
  let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const value = values.filter(v => v && String(v).length).map(v => v.trim()).join(' ').trim();
  return value.length ? value : null;
}; // Returns an array for the passed string value by splitting on whitespace.
//
//   attributeValues('one two three ') // ['one', 'two', 'three']
//

export const attributeValues = value => {
  if (!value) return [];
  if (!value.length) return [];
  return value.split(' ').filter(v => v.trim().length);
}; // Extracts attributes from a DOM element.
//

export const extractElementAttributes = element => {
  let attrs = Array.from(element.attributes).reduce((memo, attr) => {
    memo[attr.name] = attr.value;
    return memo;
  }, {});
  attrs.checked = !!element.checked;
  attrs.selected = !!element.selected;
  attrs.tag_name = element.tagName;

  if (element.tagName.match(/select/i) || multipleInstances(element)) {
    const collectedOptions = collectCheckedOptions(element);
    attrs.values = collectedOptions;
    attrs.value = collectedOptions.join(',');
  } else {
    attrs.value = element.value;
  }

  return attrs;
}; // Extracts the dataset of an element and combines it with the data attributes from all parents if requested.
//

export const extractElementDataset = function (element) {
  let datasetAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let attrs = extractDataAttributes(element) || {};
  const dataset = datasetAttribute && element.attributes[datasetAttribute];

  if (dataset && dataset.value === 'combined') {
    let parent = element.parentElement;

    while (parent) {
      attrs = _objectSpread(_objectSpread({}, extractDataAttributes(parent)), attrs);
      parent = parent.parentElement;
    }
  }

  return attrs;
}; // Extracts all data attributes from a DOM element.
//

export const extractDataAttributes = element => {
  let attrs = {};

  if (element && element.attributes) {
    Array.from(element.attributes).forEach(attr => {
      if (attr.name.startsWith('data-')) {
        attrs[attr.name] = attr.value;
      }
    });
  }

  return attrs;
};